import React from "react";

export default function SkeletonLoader({ type = "card", count = 3 }) {
  const items = Array.from({ length: count });

  return (
    <div className="skeleton-container py-4 px-2" aria-label="Loading content">
      <style>{`
        @keyframes skeletonPulse {
          0% { opacity: 0.6; }
          50% { opacity: 0.3; }
          100% { opacity: 0.6; }
        }
        .skeleton-box {
          background: linear-gradient(90deg, #1E3E72 0%, #0B1D37 50%, #1E3E72 100%);
          animation: skeletonPulse 1.5s ease-in-out infinite;
          border-radius: 12px;
        }
      `}</style>
      <div className="row g-4">
        {items.map((_, i) => (
          <div className="col-12 col-md-4" key={i}>
            <div className="p-4 rounded-4 border border-secondary" style={{ background: "rgba(11, 29, 55, 0.5)" }}>
              <div className="skeleton-box mb-3" style={{ height: "180px", width: "100%" }} />
              <div className="skeleton-box mb-2" style={{ height: "24px", width: "70%" }} />
              <div className="skeleton-box mb-2" style={{ height: "16px", width: "90%" }} />
              <div className="skeleton-box" style={{ height: "16px", width: "40%" }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
